import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AdvisoryModel } from '../data';
import { ApiClientInterface } from '../../client/api/api-client.interface';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class AdvisoryModelApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(): Observable<Transaction<AdvisoryModel[]>> {
        return this.transactionRequest.wrap(this.apiClient.getAdvisoryModels());
    }
}
